import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, Injector, Input, NgModule, OnChanges, ViewEncapsulation } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { EmailContactEntity, Entity } from '@jms/model';
import { AvatarModule } from '@jms/ui/ui.avatar';
import { PickerItemModule } from '@jms/ui/ui.picker.item';
import { PickerBaseComponent } from '@jms/ui/ui.pickers.base';
import { NgSelectModule } from '@ng-select/ng-select';
import Enumerable from 'linq';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { catchError, map, Observable, of } from 'rxjs';

@Component({
    selector: 'email-recipient-picker',
    templateUrl: './email.recipient.picker.component.html',
    styleUrls: ['./email.recipient.picker.component.less'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: EmailRecipientPickerComponent, multi: true }
    ],
    standalone: false
})
export class EmailRecipientPickerComponent extends PickerBaseComponent implements OnChanges {

  @Input() public placeholder = '<Recipients>';
  @Input() public appendTo;
  @Input() public multiple: boolean;
  @Input() public parentId: string;

  public data$: Observable<Entity[]>;

  constructor(
    injector: Injector,
    private http: HttpClient
  ) {
    super(injector);
  }

  public ngOnChanges() { }

  public onFindRecipients(query: string) {

    this.data$ = this.getRecipients(query);

  }

  private getRecipients(query: string): Observable<EmailContactEntity[]> {

    const url = this.parentId
      ? `/api/picker/contact/email/recipient/${this.parentId}?filter=${query}`
      : `/api/picker/contact/email/recipient?filter=${query}`;

    return this.http.get<EmailContactEntity[]>(url)
      .pipe(
        map(x => Enumerable.from(x).where(x => !!x?.email).orderBy(x => x.name).toArray()),
        catchError(error => {
          return of([]);
        })
      );


  }
}

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgSelectModule,
    PickerItemModule,
    AutoCompleteModule,
    AvatarModule
  ],
  declarations: [
    EmailRecipientPickerComponent
  ],
  providers: [],
  exports: [
    EmailRecipientPickerComponent
  ],
})
export class EmailRecipientPickerModule { }
